import { useCallback } from 'react'

import {
  Box,
  Button,
  Icon,
  IconButton,
  Link,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  StackDivider,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'

import PatchNotesSection from './PatchNotesSection'

const PatchNotesModal = ({ version }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const removePreviousViewed = useCallback(() => {
    for (let i = 0; i < localStorage.length; i++) {
      let key = localStorage.key(i)

      if (key.startsWith('patchNotes-') && key.endsWith('-viewed')) {
        localStorage.removeItem(key)
      }
    }
  }, [])

  const setViewed = useCallback(() => {
    removePreviousViewed()
    localStorage.setItem(`patchNotes-${version}-viewed`, true)
    onClose()
  }, [])

  // const getViewed = useCallback(() => {
  //   return localStorage.getItem(`patchNotes-${version}-viewed`)
  // }, [])

  // useEffect(() => {
  //   if (!getViewed()) onOpen()
  // }, [])

  return (
    <>
      <IconButton
        icon={<Icon as={InformationCircleIcon} />}
        fontSize='2xl'
        onClick={onOpen}
      >
        What&apos;s New
      </IconButton>
      <Modal isOpen={isOpen} size='2xl' scrollBehavior='inside'>
        <ModalOverlay />
        <ModalCloseButton />
        <ModalContent>
          <ModalHeader>What&apos;s New</ModalHeader>
          <ModalBody>
            <Stack divider={<StackDivider />}>
              <PatchNotesSection
                title='Casework Changes'
                description={
                  <Box>
                    <UnorderedList>
                      <ListItem>
                        Council Member Field added to Casework
                      </ListItem>
                      <ListItem>Prior tab added to Casework</ListItem>
                      <ListItem>
                        Comments field disabled for new Casework
                      </ListItem>
                      <ListItem>
                        Support added for vacant district offices
                      </ListItem>
                    </UnorderedList>
                  </Box>
                }
              />
              <PatchNotesSection
                title='Reports'
                description={
                  <UnorderedList>
                    <ListItem>Inactive staff removed from reports</ListItem>
                  </UnorderedList>
                }
              />
              <PatchNotesSection
                title='QOL Updates'
                description={
                  <Box>
                    <UnorderedList>
                      <ListItem>Topics now exportable for all staff</ListItem>
                      <ListItem>
                        Link and modal for potential NYCHA tickets added
                      </ListItem>
                      <ListItem>
                        Casework tags can now be merged in Compendium
                      </ListItem>
                      <ListItem>Updated styles of tabs</ListItem>
                    </UnorderedList>
                  </Box>
                }
              />
              <PatchNotesSection
                title='Hotfixes'
                description={
                  <Box>
                    <UnorderedList>
                      <ListItem>
                        Fixed an issue where searching casework with special
                        characters would cause errors
                      </ListItem>
                      <ListItem>
                        Fixed an issue where clearing constituent addresses
                        failed
                      </ListItem>
                      <ListItem>
                        Fixed an issue with pagination on other casework tabs
                      </ListItem>
                    </UnorderedList>
                  </Box>
                }
              />
              <PatchNotesSection
                title='Developer Notes'
                description={
                  <Box>
                    <Box>
                      If you have any questions, concerns, or requests, contact:
                      <UnorderedList>
                        <ListItem>
                          Yogi Rosario -{' '}
                          <Link
                            color='blue.600'
                            href='mailto: yrosario-doran@council.nyc.gov'
                          >
                            yrosario-doran@council.nyc.gov
                          </Link>
                        </ListItem>
                      </UnorderedList>
                    </Box>
                  </Box>
                }
              />
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' onClick={setViewed}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default PatchNotesModal
